import React, { Component } from "react";
import { withRouterParams } from "../utils/withRouterParams";
import { BASE_API, AppToaster } from "../utils/constants";
import DashboardWrapper from "../components/DashboardWrapper";
import BackgroundLayer from "../components/BackgroundLayer";
import AdminEchipe from "../components/admin/AdminEchipe";
import AdminAntrenori from "../components/admin/AdminAntrenori";
import Submenu from "../components/Submenu";
import { getSession } from "../utils/helpers";

class CoachDashboard extends Component {
    static pageType = "admin";

    constructor(props) {
        super(props);
        this.state = {
            organizationId: "",
            organizationName: "",
            teams: [],
            coaches: [],
            loading: false,
        };
    }

    /* ───────────────────────────────  Lifecycle  ─────────────────────────────── */

    componentDidMount() {
            // organizația activă din session
            const session = getSession();
            const organizationId = session?.organization?.id;
            const organizationName = session?.organization?.organization_name;
    
            this.setState({ organizationId, organizationName }, this.getData);
        }
    
        /* ───────────────────────────────    API calls   ───────────────────────────── */
        getTeams = async () => {
            this.setState({ loading: true });
    
            /* momentul curent (fus orar browser) */
            const now = new Date();
            const todayStr = now.toISOString().slice(0, 10);     // YYYY-MM-DD
            const timeNow = now.toLocaleTimeString("ro-RO", {
                hour: "2-digit",
                minute: "2-digit",
                hour12: false,
            });
    
            /* 1 iulie anul precedent */
            const fromDate = `${now.getFullYear() - 1}-07-01`;
    
            /* date din sesiune */
            const session = JSON.parse(localStorage.getItem("session") || "{}");
            const userId = session?.user?.id;
            const userRole = session?.user?.user_role;
            const orgId = session?.organization?.id;          // UUID organizație
    
            if (!userId) {
                AppToaster.show({ message: "Sesiune expirată – relogați-vă.", intent: "danger" });
                this.setState({ loading: false });
                return;
            }
    
            /* construire URL */
            let url = `${BASE_API}/api/admin/teams`
                + `?userId=${userId}`
                + `&from=${fromDate}`
                + `&today=${todayStr}`
                + `&timeNow=${timeNow}`;
    
            /* doar superadmin trimite organizationId (filtru) */
            if (userRole === "superadmin" && this.state.organizationId) {
                url += `&organizationId=${this.state.organizationId}`;
            }
    
            try {
                const res = await fetch(url);
                const json = await res.json();
                if (!res.ok) throw new Error(json.error || "Eroare necunoscută");
    
                this.setState({ teams: json.teams ?? [], loading: false });
    
            } catch (err) {
                AppToaster.show({
                    message: err.message || "Eroare la încărcarea echipelor",
                    intent: "danger",
                });
                this.setState({ loading: false });
            }
        };
    
        getData = async () => {
            this.setState({ loading: true });
            try {
                await Promise.all([this.getTeams(), 
                ]);
            } catch {
                AppToaster.show({
                    message: "Eroare la încărcarea datelor",
                    intent: "danger",
                });
            } finally {
                this.setState({ loading: false });
            }
        };
    

    /* ───────────────────────────────  View switch  ───────────────────────────── */

    renderActiveView = () => {
        // tab & org luate din query-string
        const search = new URLSearchParams(this.props.location.search);
        const tab = search.get("tab");  // "echipe" | "antrenori"
        // const orgSlug = search.get("org");   // disponibil dacă vei avea nevoie

        const {
            organizationId,
            organizationName,
            teams,
            coaches,
        } = this.state;
        const onlyCoaches = coaches.filter((u) => u.role === "coach");
        console.log(teams)
        switch (tab) {
            case "dashboard":
                return (
                    <AdminEchipe
                        organizationId={organizationId}
                        organizationName={organizationName}
                        teams={teams}
                        coaches={onlyCoaches}
                        getTeams={this.getTeams}
                        getData={this.getData}
                    />
                );
            
            default:
                return <div>Selectează o secțiune din submenu.</div>;
        }
    };

    /* ───────────────────────────────    Render     ───────────────────────────── */

    render() {
        return (
            <div id="adminDashboard" className="layout-center">
                <BackgroundLayer
                    imgPath="./../images/"
                    isBgVisible={this.props.isBgVisible}
                />

                {/* Submeniu dinamic bazat pe query-string */}
                <Submenu role="coach" />

                <DashboardWrapper>{this.renderActiveView()}</DashboardWrapper>
            </div>
        );
    }
}

export default withRouterParams(CoachDashboard);
